export const FundNameForPresentation = {
  fundStandardName: 'fundStandardName',
  name: 'name'
};
